<template>
  <div class="box6-page">
    <img
      class="logo"
      src="../../../assets/coursePage/inseec/box6/logo.png"
      alt=""
    />
    <div class="inseec-title">INSEEC 工商管理硕士(MBA)</div>
    <div class="card-box">
      <div class="item">
        <div class="label">专业详情</div>
        <div class="major">
          <div class="major-top">
            <img src="../../../assets/coursePage/inseec/box6/pic.png" alt="" />
          </div>
          <div class="major-bottom">
            法国INSEEC高等商学院（INSEEC School of Business）, 是全球顶尖 1%
            精英高等商学院，已获得AACSB、EFMD、AMBA三重权威认证。欧洲最国际化的精英商学院，
            2019全球管理学硕士第85位，金融市场、操盘与风险管理专业,
            全法排名第一。所有课程落地在中国完成，不出国门可以获得硕士学位。为学员打造具备国际沟通能力、领导能力、善于参与国际事务和国际竞争的全球化高级管理者。
          </div>
        </div>
      </div>
      <div class="item">
        <div class="label">课程内容</div>
        <div class="course">
          <div class="course-desc">
            <p>在线形式录播课使报名者能够逐步进行个性化的学习</p>
            <p>课程共有8个模块：100%在线-150h-60学分</p>
            <span>*实际课程安排以学校每学期通知为准</span>
          </div>
          <div class="course-collapse">
            <div
              class="collapse-item"
              v-for="(item, index) in collapseList"
              :key="index"
            >
              <div class="collapse-header" @click="toggleCollapse(index)">
                <span class="collapse-title">{{ item.title }}</span>
                <span class="collapse-icon" :class="{ active: item.isActive }">
                  <img
                    src="../../../assets/coursePage/inseec/box6/icon-close.png"
                    alt=""
                  />
                  <img
                    src="../../../assets/coursePage/inseec/box6/icon-open.png"
                    alt=""
                  />
                </span>
              </div>
              <div class="collapse-content" v-show="item.isActive">
                <div class="content-inner">
                  <p>{{ item.description }}</p>
                  <ul class="unit-list">
                    <li
                      v-for="(unit, unitIndex) in item.units"
                      :key="unitIndex"
                    >
                      {{ unit }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="label">学习模式</div>
        <div class="mode">
          <div class="mode-item">
            <img
              src="../../../assets/coursePage/inseec/box6/icon1.png"
              alt=""
            />
            <div>
              <h4>上课形式</h4>
              <p>纯线上学习，不需要离职，不需要脱产</p>
            </div>
          </div>
          <div class="mode-item">
            <img
              src="../../../assets/coursePage/inseec/box6/icon2.png"
              alt=""
            />
            <div>
              <h4>毕业方案</h4>
              <p>学生修满学分，可获得国外院校颁发的硕士学位证书</p>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="label">师资教授</div>
        <div class="teacher">
          <div class="teacher-item">
            <div>
              <img
                src="../../../assets/coursePage/inseec/box6/teacher1.png"
                alt=""
              />
              <h4>Jean-Pierre Helfer</h4>
            </div>
            <p>
              巴黎大学战略管理和市场营销教授（巴黎第一大学先贤祠-索邦分校）。JP
              Helfer
              在管理、战略、营销、会计领域撰写了许多著作，并参与了法国和国外的许多教育项目。
            </p>
          </div>
          <div class="teacher-item">
            <div>
              <img
                src="../../../assets/coursePage/inseec/box6/teacher2.png"
                alt=""
              />
              <h4>BernardMartory</h4>
            </div>
            <p>
              尼斯索菲亚-安蒂波利斯大学教授，管理科学副教授。人力资源管理和社会管理控制顾问。专业协会副主席：IPSOC“信息和社会指导”。著有
              4 本人力资源管理著作和多篇文章。
            </p>
          </div>
          <div class="teacher-item">
            <div>
              <img
                src="../../../assets/coursePage/inseec/box6/teacher3.png"
                alt=""
              />
              <h4>Michel-Kalika</h4>
            </div>
            <p>
              大学教授，在巴黎第九大学的EMBA 课程中教授了 15
              年的战略管理。他目前是商业科学研究所的科学顾问。
            </p>
          </div>
          <div class="teacher-item">
            <div>
              <img
                src="../../../assets/coursePage/inseec/box6/teacher4.png"
                alt=""
              />
              <h4>Christine Triomphe</h4>
            </div>
            <p>
              管理科学博士，巴黎 IAE
              讲师。她在巴黎的MBA课程和国际项目中负责运营管理（供应链管理，流程改进，精益6Sigma）以及项目管理和创新的课程。
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "",
    data() {
      return {
        collapseList: [
          {
            title: "战略管理",
            description:
              "本课程一方面介绍了分析公司战略方法的所有工具、概念和方法，另一方面介绍了在最佳条件下实施战略选择的方法。",
            units: [
              "单元 1: 当前的管理挑战",
              "单元 2: 战略方针",
              "单元 3: 战略的范围",
              "单元 4: 外部诊断工具",
              "单元 5: 内部诊断工具",
              "单元 6: 业务战略方向",
              "单元 7: 企业战略方向",
              "单元 8: 国际战略",
              "单元 9: 战略的执行",
              "单元 10: 战略和结构选择",
              "单元 11: 战略和团队动员",
              "单元 12: 战略变革管理",
            ],
            isActive: true,
          },
          {
            title: "金融基础",
            description:
              "本课程介绍财务管理的基本概念和方法，从财务分析到项目或投资管理和估值。因此，讨论了金融数学和市场金融的一些方面。所选择的方法是一种操作方法，允许在课程框架内立即实施，但最重要的是在专业配置中实施。该课程的结构旨在反映经理人的方法，了解财务逻辑，并逐步将其应用于他或她参与的不同领域。",
            units: [
              "单元 1：接触财务文件",
              "单元 2：利润和增值",
              "单元 3：EBITDA，EBE，交易现金流",
              "单元 4：BFR 及其变化",
              "单元 5：净流量和现值",
              "单元 6：投资的财务评估",
              "单元 7：到岸价格，总现金流量和股东报酬",
              "单元 8：财务结构的主要余额",
              "单元 9：投资，战略发展和金融政策",
              "单元 10：债务问题",
              "单元 11：增资和估值",
              "单元 12：估值和金融市场",
            ],
            isActive: false,
          },
          {
            title: "可持续发展与绿色管理",
            description:
              "我们正处于一个重大的过渡阶段，可持续发展和企业社会责任(CSR)可以引导我们走上绿色和负责任增长的新道路。可持续发展必须被视为一种新的经济发展范式，其价值观和原则能够对我们正在经历的经济，生态，社会甚至道德危机作出反应。",
            units: [
              "单元 1：从可持续发展(SD)到绿色经济",
              "单元 2：可持续发展：竞争力问题",
              "单元 3：能源和生态转型的挑战",
              "单元 4：在不确定情况下采取行动",
              "单元 5：行动领域，可持续发展和绿色管理",
            ],
            isActive: false,
          },
          {
            title: "人力资源战略管理",
            description:
              "本课程旨在将社会战略纳入企业的整体战略思维。提出了当代人力资源管理的关键战略问题。它在战略社会和社会经济指导的逻辑范围内提供适当的答案。它论述了企业和组织基本选择的组织内容和社会内容。",
            units: [
              "单元 1：思考战略社会管理",
              "单元 2：管理组织变革",
              "单元 3：发展技能",
              "单元 4：实施员工队伍和能力战略管理（G.P.E.C.）",
              "单元 5：了解薪酬系统的平衡",
              "单元 6：改变组织的薪酬制度",
              "单元 7：管理薪酬和工资单",
              "单元 8：管理招聘和更替",
              "单元 9：分析旷工和社会气氛",
              "单元 10：定义和分析社会绩效",
              "单元 11：衡量和管理社会绩效：管理接力",
              "单元 12：建立社会经济指导工具",
            ],
            isActive: false,
          },
          {
            title: "运营与供应链",
            description:
              "本课程旨在为学员提供供应链管理的基础知识。它还旨在提高国际一级对供应链概念和原则的理解。三个主要目标是：（1）掌握该部门使用的词汇，概念，工具和技术；（2）发展必要的技能，以理解供应链与组织其他决策单位之间的相互作用；（3）了解与供应链相关的战略挑战。",
            units: [
              "单元 1：SCM 介绍",
              "单元 2：供应链设计网络",
              "单元 3：仓库和配送中心管理",
              "单元 4：运输战略",
              "单元 5：供应链与物流服务提供商",
              "单元 6：库存管理",
              "单元 7：生产计划与控制系统",
              "单元 8：物料需求计划",
              "单元 9：供应链成本计算案例研究",
              "单元 10：供应链性能",
              "单元 11：精益制造和改进方法",
              "单元 12：供应链融资",
            ],
            isActive: false,
          },
          {
            title: "创新管理",
            description:
              "公司现在正在寻求改进新产品/服务的创造和开发过程，促进创新和快速产品更新。为此，项目管理已经发展起来，并在企业的组织和运作中占有越来越大的地位。在你的职业生涯中，你们都将参与或管理一个项目，因此，本课程旨在使您掌握项目运营管理的基本技术：评估，时间和资源规划，成本控制，项目进度监控，成本目标设计，盈利能力管理，风险管理等。组织和管理创新的新方法，如敏捷方法，设计思维，节俭创新或开放创新，正在迅速传播；知道如何实施这些方法，领导创新团队等等，都是今天所需要的技能之一。拥有项目管理和创新方面的培训受到企业的追捧；它是进入一个激动人心的世界的大门，这个世界正在塑造公司的未来和我们未来的环境。",
            units: [
              "单元 1：创新管理",
              "单元 2：新产品设计项目管理",
              "单元 3：新产品设计项目的管理",
              "单元 4：以用户为中心的创新",
              "单元 5：颠覆性创新方法",
            ],
            isActive: false,
          },
          {
            title: "数字世界中的营销",
            description:
              "市场营销和数字市场营销是紧密相连的，本课程提供了一个机会来发现所部署的战略和需要知道的工具，以发展您的业务，改善您的品牌形象和声誉，并衡量所决定的行动及其影响。本单元介绍了几位专家的证词。",
            units: [
              "单元 1：数字化世界",
              "单元 2：营销基础",
              "单元 3：战略规划",
              "单元 4：目标确定和数据（在线）",
              "单元 5：不同的数字格式",
              "单元 6：数字平台",
              "单元 7：测量",
            ],
            isActive: false,
          },
          {
            title: "掌握项目管理",
            description:
              "本课程介绍了管理和领导一个项目的关键和基本过程。参与者将学习如何：（1）利用功能分析表达和组织需求；（2）评估项目的可行性；（3）建立适当的组织来进行项目；（4）利用方法和工具来管理项目的资源，时间，风险和成本。",
            units: [
              "单元 1：初始化项目",
              "单元 2：发现 PMI 存储库",
              "单元 3：将客户需求集成到项目存储库中",
              "单元 4：确定项目的临时时间表",
              "单元 5：估算任务和成本：管理资源",
              "单元 6：管理采购",
              "单元 7：管理项目进展",
              "单元 8：控制风险",
            ],
            isActive: false,
          },
        ],
      };
    },
    methods: {
      toggleCollapse(index) {
        // 手风琴模式：展开一个项时关闭所有其他项
        this.collapseList.forEach((item, i) => {
          if (i !== index) {
            item.isActive = false;
          }
        });
        // 切换当前项的状态
        this.collapseList[index].isActive = !this.collapseList[index].isActive;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .box6-page {
    background: #f3f5f8;
    padding: 80px 40px;
    position: relative;
    .logo {
      position: absolute;
      top: 16px;
      left: 50%;
      transform: translateX(-50%);
      width: 654px;
      height: 182px;
    }
    .inseec-title {
      font-weight: 600;
      font-size: 44px;
      color: #012d72;
      line-height: 64px;
      text-align: center;
      position: relative;
    }
    .card-box {
      margin-top: 48px;
      position: relative;
      .item {
        padding: 120px 32px 32px;
        background: #fff;
        border-radius: 32px;
        position: relative;
        margin-bottom: 40px;
        &:last-child {
          margin-bottom: 0;
        }
        .label {
          position: absolute;
          top: 24px;
          left: -16px;
          width: 230px;
          height: 76px;
          background: url("../../../assets/coursePage/inseec/box6/label_bg.png")
            no-repeat center center;
          background-size: cover;
          box-sizing: border-box;
          padding: 8px 0 0 42px;
          font-weight: 600;
          font-size: 32px;
          color: #ffffff;
          line-height: 48px;
        }
        .major {
          display: flex;
          flex-direction: column;
          align-items: center;
          .major-top {
            display: flex;
            flex-wrap: wrap;
            width: 710px;
            height: 430px;

            > img {
              width: 100%;
            }
          }
          .major-bottom {
            width: 100%;
            padding-top: 24px;
            font-weight: 400;
            font-size: 26px;
            color: #092a52;
            line-height: 48px;
          }
        }
        .course {
          .course-desc {
            margin-bottom: 30px;
            p {
              font-weight: 400;
              font-size: 26px;
              color: #092a52;
              line-height: 44px;
            }
            span {
              margin-top: 8px;
              margin-bottom: 32px;
              font-weight: 400;
              font-size: 24px;
              color: #0061ff;
              line-height: 40px;
            }
          }
          .course-collapse {
            .collapse-item {
              margin-bottom: 10px;
              overflow: hidden;
              .collapse-header {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 20px 24px;
                background: #f3f5f8;
                cursor: pointer;
                transition: background-color 0.3s;

                .collapse-title {
                  font-weight: 400;
                  font-size: 28px;
                  color: #092a52;
                  line-height: 40px;
                }
                .collapse-icon {
                  width: 24px;
                  height: 24px;
                  transition: transform 0.3s;
                  > img {
                    width: 24px;
                    height: 24px;
                    &:last-child {
                      display: none;
                    }
                  }
                  &.active {
                    > img {
                      &:first-child {
                        display: none;
                      }
                      &:last-child {
                        display: block;
                      }
                    }
                  }
                }
              }
              .collapse-content {
                transition: max-height 0.3s ease-out;
                .content-inner {
                  padding: 20px 24px;
                  background-color: #fff;
                  p {
                    font-weight: 400;
                    font-size: 22px;
                    color: #092a52;
                    line-height: 32px;
                    margin-bottom: 16px;
                  }
                  .unit-list {
                    li {
                      font-weight: 500;
                      font-size: 26px;
                      color: #092a52;
                      line-height: 48px;
                      display: flex;
                      &::before {
                        content: "";
                        width: 8px;
                        height: 8px;
                        background-color: #ff5656;
                        margin-right: 12px;
                        margin-top: 20px;
                      }
                    }
                  }
                }
              }
            }
          }
        }
        .mode {
          display: flex;
          flex-direction: column;
          .mode-item {
            display: flex;
            box-sizing: border-box;
            padding: 40px 26px 40px 32px;

            &:first-child {
              background: url("../../../assets/coursePage/inseec/box6/bg1.png")
                no-repeat center center;
              background-size: cover;
              margin-bottom: 30px;
            }
            &:last-child {
              background: url("../../../assets/coursePage/inseec/box6/bg2.png")
                no-repeat center center;
              background-size: cover;
            }
            > img {
              width: 48px;
              height: 48px;
              margin-right: 24px;
            }
            > div {
              > h4 {
                font-weight: 600;
                font-size: 32px;
                color: #122a4f;
                line-height: 48px;
                margin-bottom: 16px;
              }
              > p {
                font-weight: 400;
                font-size: 26px;
                color: #51627d;
                line-height: 40px;
              }
            }
          }
        }
        .teacher {
          .teacher-item {
            display: flex;
            flex-direction: column;
            background: #f3f5f8;
            border-radius: 26px;
            padding: 32px 40px;
            margin-bottom: 20px;

            &:last-child {
              margin-bottom: 0;
            }
            > div {
              display: flex;
              align-items: center;
              margin-bottom: 16px;
              > img {
                width: 120px;
                height: 120px;
                margin-right: 48px;
              }
              > h4 {
                font-weight: 600;
                font-size: 36px;
                color: #122a4f;
                line-height: 44px;
              }
            }

            p {
              font-weight: 400;
              font-size: 26px;
              color: #092a52;
              line-height: 40px;
            }
          }
        }
      }
    }
  }
</style>
